import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  useMediaQuery,
} from '@mui/material'
import { COLOR } from 'constant'
import { useActions, useAppSelector } from 'hooks'
import React, { useState } from 'react'

const MultiCountrySelectPanel = () => {
  const countryData = useAppSelector(({ vibrancy }) => vibrancy.countryData)
  const multiSelectedCountries = useAppSelector(({ AIMetric }) => AIMetric.multiSelectedCountries)
  const { setMultiSelectedCountries } = useActions()
  const [error, setError] = useState<boolean>(false)
  const isSmaller600 = useMediaQuery('(max-width:600px)')
  const isSmaller800 = useMediaQuery('(max-width:800px)')

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (multiSelectedCountries.length === 2 && !event.target.checked) {
      setError(true)
    } else if (multiSelectedCountries.length === 5 && event.target.checked) {
      setError(true)
    } else {
      setError(false)
      if (event.target.checked) {
        setMultiSelectedCountries([...multiSelectedCountries, event.target.name])
      } else {
        setMultiSelectedCountries(multiSelectedCountries.filter((i) => i !== event.target.name) ?? [])
      }
    }
  }

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '300px',
        border: `2px solid ${COLOR.DARK}`,
        borderRadius: '15px',
        padding: '20px',
        marginTop: '4px',
      }}
    >
      <FormControl component='fieldset' variant='standard' sx={{ width: '100%' }}>
        <FormLabel focused={false} sx={{ color: COLOR.DARK, mb: 1.5 }} component='legend'>
          Select up to five countries for comparison:
        </FormLabel>
        <FormGroup
          sx={{
            display: 'grid',
            gridTemplateColumns: isSmaller800 && !isSmaller600 ? 'repeat(3, 1fr)' : 'repeat(2, 1fr)',
            columnGap: '10px',
          }}
        >
          {countryData.map((el) => (
            <FormControlLabel
              sx={{ m: 0, alignItems: 'flex-start' }}
              key={el.countryCode}
              control={
                <Checkbox
                  disableRipple
                  sx={{ padding: '2px 9px 2px 2px' }}
                  icon={
                    <span
                      style={{
                        width: 20,
                        height: 20,
                        backgroundColor: COLOR.LIGHT, // Customizable unchecked color
                        borderRadius: '50%', // Circular shape
                        display: 'inline-block',
                      }}
                    />
                  }
                  checkedIcon={
                    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'>
                      <circle cx='10' cy='10' r='10' fill={COLOR.DARK} />
                      <path
                        d='M6 10l2.5 2.5L14 7'
                        fill='none'
                        stroke={COLOR.TEXT}
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  }
                  checked={multiSelectedCountries.includes(el.countryCode)}
                  onChange={handleChange}
                  name={el.countryCode}
                />
              }
              checked={true}
              label={el.countryName}
            />
          ))}
        </FormGroup>
        {error && (
          <FormHelperText sx={{ color: 'red' }}>Minimum 2 and maximum 5 countries can be selected.</FormHelperText>
        )}
      </FormControl>
    </Box>
  )
}

export default MultiCountrySelectPanel
